import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [colorTheme, setColorTheme] = useState(() => {
    const current = localStorage.getItem('sev_color_theme');
    if (['light', 'dark', 'sand'].includes(current)) return current;
    
    const oldTheme = localStorage.getItem('mieteora_theme_preference');
    if (oldTheme) {
      if (oldTheme === 'nordic') return 'light';
      if (oldTheme === 'dark') return 'dark';
      if (oldTheme === 'topnav') return 'sand';
    }
    return 'light';
  });
  
  const [density, setDensity] = useState(() => {
    const current = localStorage.getItem('sev_table_density');
    return current === 'compact' ? 'compact' : 'comfortable';
  });

  const [navLayout, setNavLayout] = useState(() => {
    const current = localStorage.getItem('sev_nav_layout');
    if (['sidebar', 'topnav'].includes(current)) return current;
    
    const oldTheme = localStorage.getItem('mieteora_theme_preference');
    if (oldTheme === 'topnav') return 'topnav';
    return 'sidebar';
  });

  useEffect(() => {
    localStorage.removeItem('mieteora_theme_preference');
  }, []);

  useEffect(() => {
    localStorage.setItem('sev_color_theme', colorTheme);
    localStorage.setItem('sev_nav_layout', navLayout);
    localStorage.setItem('sev_table_density', density);

    const root = document.documentElement;
    root.classList.remove('theme-light', 'theme-dark', 'theme-sand', 'theme-nordic', 'theme-topnav', 'dark', 'layout-sidebar', 'layout-topnav', 'density-compact', 'density-comfortable');
    
    root.classList.add(`theme-${colorTheme}`);
    root.classList.add(`layout-${navLayout}`);
    root.classList.add(`density-${density}`);
    
    if (colorTheme === 'dark') {
      root.style.colorScheme = 'dark';
      root.classList.add('dark');
    } else {
      root.style.colorScheme = 'light';
    }
  }, [colorTheme, navLayout, density]);

  const changeColorTheme = (newTheme) => {
    if (['light', 'dark', 'sand'].includes(newTheme)) {
      setColorTheme(newTheme);
    }
  };

  const changeDensity = (newDensity) => {
    if (['comfortable', 'compact'].includes(newDensity)) {
      setDensity(newDensity);
    }
  };

  const changeNavLayout = (newLayout) => {
    if (['sidebar', 'topnav'].includes(newLayout)) {
      setNavLayout(newLayout);
    }
  };

  return (
    <ThemeContext.Provider value={{ colorTheme, navLayout, density, changeColorTheme, changeNavLayout, changeDensity }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
